import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { membershipSubscriptionsBackend } from './membership-subscriptions.backend';
import { membershipSubscriptionsReducer } from './membership-subscriptions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'membershipSubscriptions',
      membershipSubscriptionsReducer,
    ),
    BackendModule.forFeature(
      'membershipSubscriptions',
      membershipSubscriptionsBackend,
    ),
  ],
})
export class DatastoreMembershipSubscriptionsModule {}
